import { useEffect, useRef, useState } from "react";
import { Input } from "@components/common/input";
import { MAX_LENGTH_ANALYTICS_NAME } from "@resources/Constants";
import { HVButton, HVIcon } from "@repo/HVComponents";
import { useLang } from "@hooks/useLang";
import useDetectOutsideClick from "@hooks/useDetectOutsideClick";
import { ICON } from "src/constants/icons";
import * as S from "../AnalyticsPage.styled";

type Props = {
  isEditing?: boolean;
  value?: string;
  onSubmit?: (value: string) => void;
};

const EditableInput = ({ isEditing, value, onSubmit }: Props) => {
  const { translate } = useLang();
  const inputRef = useRef<HTMLInputElement>(null);
  const formRef = useRef<HTMLFormElement>(null);
  const [inputValue, setInputValue] = useState(value);
  useDetectOutsideClick(formRef, () => onSubmit?.(inputValue || ""));

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    if (!isEditing) {
      setInputValue(value);
    }
  }, [isEditing]);

  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus();
    }
  }, [isEditing, inputRef]);

  if (!isEditing) {
    return <S.FilterName>{value ?? translate("filter_name")}</S.FilterName>;
  }

  return (
    <form
      ref={formRef}
      style={{ position: "relative" }}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.(inputValue || "");
      }}
    >
      <Input
        innerRef={inputRef}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        style={{
          width: "200px",
          height: "32px",
          paddingRight: 35
        }}
        maxLength={MAX_LENGTH_ANALYTICS_NAME}
      />
      <HVButton
        variant="Ghost"
        buttonContainerProps={{
          w: 20,
          h: 20,
          p: 0,
          styles: {
            root: {
              position: "absolute",
              right: 8,
              top: 16,
              transform: "translateY(-50%)"
            }
          }
        }}
        onClick={(e) => {
          e.stopPropagation();
          setInputValue("");
          inputRef.current?.focus();
        }}
      >
        <HVIcon
          name="fail"
          theme="fill"
          scale="large"
          size="20"
          svgProps={{
            ...ICON.SIZE_20,
            stroke: "var(--hv-text-on-brand-tertiary) !important"
          }}
        />
      </HVButton>
    </form>
  );
};

export default EditableInput;
